var exports = {
  "o7": "xa15a2ab7--8cde3b--category-tabs",
  "Mf": "xa15a2ab7--8cde3b--tab",
  "vu": "xa15a2ab7--8cde3b--active",
};

module.exports = exports;
